if ($('input.rate').length) {

    $.fn.raty.defaults.path = '/media/img/raty';
    $.fn.raty.defaults.cancel = false;

    //valoracio
    $('input.rate').each(function() {
        'use strict';
        var field = $(this);
        var id = '#' + field.attr('id');
        var rating = $('<div></div>');
        rating.raty({
            hints: ['', '', '', '', ''],
            score: function() {
                return field.val();
            },
            precision: 1,
            targetScore: id,
            click: function (data, event) {
                var target = $(this);
                var rateUrl = field.data('url-submit');
                var value = Math.round(data*2)/2; // per arrodonir a 0.5
                $.ajax(
                {
                  url : rateUrl,
                  data: {id: field.data('id'), score: value},
                  type: "POST",
                  success:function(data, textStatus, jqXHR)
                  {
                      if (data.error == false) {
                          var newScore = parseFloat(data.score);
                          var roundedNewScore = Math.round(newScore*2)/2;

                          rating.raty('score', roundedNewScore);
                          rating.raty('readOnly', true);
                      }
                  },
                  error: function(jqXHR, textStatus, errorThrown)
                  {

                  }
                });
            }
        });
        field.hide();
        field.after(rating);
    });
}
